/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPointFilled = createReactComponent("filled", "point-filled", "IconPointFilled", [["path", { "d": "M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-0" }]]);

export { IconPointFilled as default };
//# sourceMappingURL=IconPointFilled.mjs.map
